import { render, staticRenderFns } from "./AllAssignedWorkouts.vue?vue&type=template&id=3c5e624a&scoped=true&"
import script from "./AllAssignedWorkouts.vue?vue&type=script&lang=js&"
export * from "./AllAssignedWorkouts.vue?vue&type=script&lang=js&"
import style0 from "./AllAssignedWorkouts.vue?vue&type=style&index=0&id=3c5e624a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e624a",
  null
  
)

export default component.exports